export interface Brand {
  uuid: string | null;
  name: string;
  logo_url: string;
  icon_url: string;
  socials: {
    type: SocialType;
    handle: string;
  }[];
}

export enum SocialType {
  TWITTER = 'twitter',
  FACEBOOK = 'facebook',
  INSTAGRAM = 'instagram',
  YOUTUBE = 'youtube',
  TIKTOK = 'tiktok',
}
